import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  genders: []
}

export const mutations = {
  SET_GENDERS(state, genders) {
    state.genders = genders
  }
}

export const actions = {
  fetchGenders({ commit }) {
    return ApiService.fetchGenders()
      .then(res => {
        const genders = res.data.data
        commit('SET_GENDERS', genders)
      })
      .catch(error => {
        throw error
      })
  }
}
